var map = {
	"./Copy.vue": 77384,
	"./DownloadList.vue": 19927,
	"./Famous - 副本.vue": 40294,
	"./Famous.vue": 18052,
	"./FamousInfo.vue": 35852,
	"./Floorplan.vue": 60002,
	"./History.vue": 15737,
	"./Index.vue": 45621,
	"./News.vue": 8330,
	"./NewsInfo.vue": 51510,
	"./NotFound.vue": 39210,
	"./SinglePage.vue": 86818,
	"./UserChangePassword.vue": 26093,
	"./UserEdit.vue": 71654,
	"./UserExhibition.vue": 20145,
	"./UserForgotPassword.vue": 60040,
	"./UserLogin.vue": 90633,
	"./UserLogout.vue": 2868,
	"./UserRegister.vue": 72293,
	"./UserReserve.vue": 95986,
	"./UserReserveInfo.vue": 97902,
	"./VueCropper.vue": 17064,
	"./upload-cropper.vue": 65736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81521;